import { QueryClient, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../constants';
import { eventsService } from '../../services';
import { useCallback } from 'react';

export const prefetchGetPublicEventInstanceByAliasQuery =
	async (queryClient: QueryClient, eventAlias: string, shortLocalInstance?: string, source?: string) => (
		await queryClient.prefetchQuery({
			queryKey: queryKeys.eventInstance(eventAlias, shortLocalInstance),
			queryFn: async () => eventsService.getPublicEventInstanceByAlias(eventAlias, shortLocalInstance, source),
			staleTime: 60000
		})
	);

export const usePrefetchGetPublicEventInstanceByAliasQuery = () => {
	const queryClient = useQueryClient();

	return useCallback(async (eventAlias: string, shortLocalInstance?: string, source?: string) => (
		await prefetchGetPublicEventInstanceByAliasQuery(queryClient, eventAlias, shortLocalInstance, source)
	), [queryClient]);
}

export const useGetPublicEventInstanceByAliasQuery = (eventAlias: string, shortLocalInstance?: string, source?: string) => (
	useQuery(
		queryKeys.eventInstance(eventAlias, shortLocalInstance),
		async () => eventsService.getPublicEventInstanceByAlias(eventAlias, shortLocalInstance, source),
		{ enabled: !!eventAlias && !!shortLocalInstance, staleTime: 60 * 1000 }
	)
);
